import { Button, styled } from '@mui/material';

const AppBarButton = styled(Button)(({ theme }) => ({
    paddingInline: '9px',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: 'transparent !important',
        color: `${theme.palette.landing.brandOrange} !important`,
    },
}));

export default AppBarButton;